import { getLoginUsername } from "../../reducers/PermissionsReducer";
import { getService } from "../../reducers/service";
import {
	getChangedFields,
	logAuditEntry,
} from "../../reducers/VehiclesReducer";
import { serviceNames } from "../../utils/constants";

export const getVehicleData = async (id) => {
	const service = await getService(serviceNames.perVehicles);
	return service.find({
		query: {
			id,
			isDeleted: false,
		},
	});
};

export const updateVehicleData = async (id, data, userAgency, oldData = {}) => {
	try {
		const service = await getService(serviceNames.perVehicles);
		const response = await service.patch(id, data);

		const changes = getChangedFields(oldData, data);

		await logAuditEntry({
			action: "UPDATE",
			recordId: id,
			oldValues: changes.old,
			newValues: changes.new,
			changedBy: getLoginUsername() || "",
			agencyId: userAgency,
		});
		return response;
	} catch (e) {}
};

export const getMakeOptions = async (userAgency) => {
	const service = await getService(serviceNames.perVehicleMakeOptions);
	const response = await service.find({
		query: {
			agencyId: userAgency,
			isDeleted: false,
		},
	});

	return response?.map((value) => ({
		label: value,
		value,
	}));
};

export const getModelOptions = async (userAgency) => {
	const service = await getService(serviceNames.perVehicleModelOptions);
	const response = await service.find({
		query: {
			agencyId: userAgency,
			isDeleted: false,
		},
	});

	return response?.map((value) => ({
		label: value,
		value,
	}));
};

export const getYearOptions = async (userAgency) => {
	const service = await getService(serviceNames.perVehicleYearOptions);
	const response = await service.find({
		query: {
			agencyId: userAgency,
			isDeleted: false,
		},
	});

	return response?.map((value) => ({
		label: value,
		value,
	}));
};
